import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Button } from "../../Common";
import styles from "./Customer.module.css";
import { updateCustomer } from "../../api";
import CommentModal from "../../Common/CommentModal/commentModal";
import DropDown from "../../Common/DropDown/index";
import { employeeTypeOptions, empStatusList } from "../../utils/utils";
import Input from "../../Common/V2/Widgets/Input";

const EmployeeDetail = ({ data, isEditable, refreshDetails, listStatus }) => {
  const [isEdit, setIsEdit] = useState(false);
  const [empStatus, setEmpStatus] = useState(data.empStatus);
  const [empcomp, setEmpcomp] = useState(data.empcomp);
  const [business, setBusiness] = useState(data.business);
  const [employmentType, setEmploymentType] = useState(data.business);
  const [isBroker, setIsBroker] = useState(data.isBroker);
  const [isDirector, setIsDirector] = useState(data.directorOf);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isComment, setIsComment] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [comment, setComment] = useState("");
  const [error, setError] = useState("");
  const [initialData, setInitialData] = useState({
    empStatus: data?.empStatus,
    empcomp: data?.empcomp || "",
    isBroker: data?.isBroker,
    isDirector: data?.isDirector || "",
    business: data?.business || "",
  });

  const updateCustomerDetail = async (custId) => {
    if (loading) return;
    setLoading(true);
    const data = {
      comment: isComment,
      employmentStatus: empStatus,
      isBroker: isBroker,
      directorOf: isDirector,
      employmentType: employmentType || "",
    };
    if (isBroker === true || isBroker === "true") {
      data.employmentCompany = empcomp;
    }

    try {
      const resp = await updateCustomer(custId, data);
      if (resp?.code === 200) {
        setIsEdit(false);
        setSuccessMessage("Details updated successfully!");
        await refreshDetails();
        setErrorMessage("");
        setTimeout(() => {
          setSuccessMessage("");
          setIsModalOpen(false);
        }, 3000);
      } else {
        setSuccessMessage("");
        setError("");
        setComment("");
        setErrorMessage(resp?.data?.message || "Something went wrong");
        setTimeout(() => {
          setIsModalOpen(false);
        }, 3000);
      }
    } catch (error) {
      setSuccessMessage("");
      setError("");
      setComment("");
      setErrorMessage(
        error?.response?.data?.message || "Failed to update details"
      );
      setTimeout(() => {
        setIsModalOpen(false);
      }, 3000);
    }
    setLoading(false);
  };

  const handleBackButton = () => {
    setEmpStatus(initialData.empStatus);
    setEmpcomp(initialData.empcomp);
    setIsBroker(initialData.isBroker);
    setIsDirector(initialData.isDirector);
    setBusiness(initialData.business);
    setEmploymentType(initialData.business);
    setIsEdit(false);
  };

  const handleSavebutton = () => {
    setIsModalOpen(true);
    setErrorMessage("");
    setError("");
    setSuccessMessage("");
    setComment("");
  };
  const handleToggleModal = () => {
    setIsModalOpen(false);
  };
  const shouldShowEmploymentType =
    empStatus === "EMPLOYED" || empStatus === "SELF_EMPLOYED";

  return (
    <div style={{ marginTop: "30px" }}>
      <Row className={styles.detailContainer}>
        <Col className="p-0">Employment Detail</Col>
        {isEditable && listStatus !== "CLOSED" && data?.accountStatus !== "CLOSED" ? (
          <Col
            md={2}
            onClick={() => setIsEdit(true)}
            style={{
              cursor: "pointer",
              display: "flex",
              justifyContent: "end",
            }}
          >
            <div style={{ width: "max-content" }}>
              {isEdit ? (
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <Button
                    title="Save"
                    margin={"0px 10px"}
                    disabled={loading}
                    onClick={handleSavebutton}
                  />
                  <Button
                    title="Back"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleBackButton();
                    }}
                  />
                </div>
              ) : (
                "Edit"
              )}
            </div>
          </Col>
        ) : (
          ""
        )}
      </Row>
      {isEdit ? (
        <>
          <Row style={{ marginTop: 10 }}>
            <Col className={styles.text}>
              <DropDown
                label="Employee Status"
                name="empStatus"
                value={empStatus}
                data={empStatusList}
                onChange={(val) => setEmpStatus(val)}
                placeholder="Select Employee Status"
              />
            </Col>
            <Col className={styles.text}>
              <Input
                label={"Employee Company"}
                value={empcomp}
                onChange={(e) => setEmpcomp(e.target.value)}
              />
            </Col>
            {shouldShowEmploymentType && (
              <Col className={styles.text}>
                <DropDown
                  label="Business"
                  name="employmentType"
                  value={employmentType}
                  data={employeeTypeOptions}
                  onChange={(val) => setEmploymentType(val)}
                  placeholder="Select Employment Type"
                />
              </Col>
            )}
            {!shouldShowEmploymentType && <Col></Col>}
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col className={styles.text}>
              <DropDown
                label="Is your employer a brokerage firm?"
                name="isBroker"
                value={
                  isBroker === true || isBroker === "true"
                    ? "Yes"
                    : isBroker === false || isBroker === "false"
                    ? "No"
                    : ""
                }
                data={[
                  { label: "Yes", value: "Yes" },
                  { label: "No", value: "No" },
                ]}
                onChange={(val) => {
                  if (val === "Yes") setIsBroker(true);
                  else if (val === "No") setIsBroker(false);
                  else setIsBroker("");
                }}
                placeholder="Select Yes or No"
              />
            </Col>
            <Col className={styles.text}>
              <Input
                label={"Director/Officer of Company"}
                value={isDirector}
                onChange={(e) => setIsDirector(e.target.value)}
              />
            </Col>
            <Col></Col>
          </Row>
        </>
      ) : (
        <>
          <Row style={{ marginTop: 10 }}>
            <Col className={styles.text}>
              Employee Status: {empStatus || "--"}
            </Col>
            <Col className={styles.text}>
              Employee Company : {empcomp || "--"}
            </Col>
            {shouldShowEmploymentType && (
              <Col className={styles.text}>
                Business :{" "}
                {employeeTypeOptions.find((opt) => opt.value === business)
                  ?.label || "--"}
              </Col>
            )}
            {!shouldShowEmploymentType && <Col></Col>}
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col className={styles.text}>
              Is your employer a brokerage firm? :{" "}
              {isBroker === true || isBroker === "true"
                ? "Yes"
                : isBroker === false || isBroker === "false"
                ? "No"
                : "--"}
            </Col>
            <Col className={styles.text}>
              Director/Officer of public Company? : {isDirector || "--"}
            </Col>
            <Col></Col>
          </Row>
        </>
      )}

      <CommentModal
        setIsComment={setIsComment}
        isOpen={isModalOpen}
        onRequestClose={handleToggleModal}
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
        errorMessage={errorMessage}
        error={error}
        setError={setError}
        comment={comment}
        setComment={setComment}
        onSave={() => updateCustomerDetail(data.customerId)}
        loading={loading}
      />
    </div>
  );
};

export default EmployeeDetail;
